import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  MenuButton,
  SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import './nav.css';
import { withRouter } from "react-router-dom";

class Navbar extends Component {

   componentDidMount() {

     const $ = window.$;

     $( 'body' ).removeClass( 'home-3' );

   }

   handleNavigation = () => {
    this.props.history.push("/contact");
  };


    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'
     

        return (
        	<div className="navbar-area">
            {/* navbar top start */}
            <div className="navbar-top 	d-none d-sm-block">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 text-center">
                      <p className='clrWhite' style={{textAlign:'center'}}>Admissions are in progress for 2025 & 2026</p>
                  </div>
                </div>
              </div>
            </div>
            <nav className="navbar navbar-area-1 navbar-area navbar-expand-lg" style={{backgroundColor:'#fff',height:100}}>
              <div className="row nav-container">
                <div className="responsive-mobile-menu">
                  <button className="menu toggle-btn d-block d-lg-none" data-target="#edumint_main_menu" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="icon-left" />
                    <span className="icon-right" />
                  </button>
                </div>
                <div className="logo mainLogo">
                  <Link to="/"><img src={publicUrl+"assets/img/website/logoMIET.png"} alt="img" width={250}/></Link>
                </div>
                <div className="nav-right-part nav-right-part-mobile">
                  {/* <a className="signin-btn" href="signin.html">Sign In</a>
                  <a className="btn btn-base" href="blog.html">Sign Up</a>
                  <a className="search-bar" href="#"><i className="fa fa-search" /></a> */}
                </div>
                <div className="collapse navbar-collapse go-top" id="edumint_main_menu">
                  <ul className="navbar-nav menu-open ">
                    {/* <li><Link to="/">Home</Link></li> */}
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/administration">Administration</Link></li>
                    <li>
                     <Menu menuButton={<MenuButton>Academics <i className="fa fa-caret-down" /></MenuButton>}>
                        <SubMenu label="Skill Development Courses">
                            <MenuItem><Link to="/ncvt-course" style={{ display: 'block', width: '100%', height: '100%' }}>NCVT Courses</Link></MenuItem>
                            <MenuItem><Link to="/industrial-school-courses" style={{ display: 'block', width: '100%', height: '100%' }}>Industrial School Courses</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Entrance Exam Courses">
                            <MenuItem><Link to="/neet-courses-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>NEET</Link></MenuItem>
                            <MenuItem><Link to="/jee-courses-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>JEE</Link></MenuItem>
                            <MenuItem><Link to="/nata-courses-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>NATA</Link></MenuItem>
                            <MenuItem><Link to="/repeater-batch-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>REPEATER'S BATCH</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Arts & Science">
                            <MenuItem><Link to="/tmg-college-of-arts-and-science" style={{ display: 'block', width: '100%', height: '100%' }}>TMG College of Arts & Science</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Distance Education Courses">
                            <MenuItem><Link to="/distance-education" style={{ display: 'block', width: '100%', height: '100%' }}>Distance Education</Link></MenuItem>
                            <MenuItem><Link to="/university-of-madras" style={{ display: 'block', width: '100%', height: '100%' }}>University of Madras</Link></MenuItem>
                            <MenuItem><Link to="/bharathidasan-university" style={{ display: 'block', width: '100%', height: '100%' }}>Bharathidasan University</Link></MenuItem>
                            <MenuItem><Link to="/tamilnadu-open-university" style={{ display: 'block', width: '100%', height: '100%' }}>Tamil Nadu Open University</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Information Technology Courses">
                            <MenuItem><Link to="/information-technology-courses" style={{ display: 'block', width: '100%', height: '100%' }}>Information Technology Courses</Link></MenuItem>
                            <MenuItem><Link to="/data-science-and-artificial-intelligence-courses" style={{ display: 'block', width: '100%', height: '100%' }}> Data Science & AI</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="School Courses">
                            <MenuItem><Link to="/school-courses" style={{ display: 'block', width: '100%', height: '100%' }}>Classes IX, X, XI, XII</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Eligibility Tests (SSC, RRB, IBPS)">
                            <MenuItem><Link to="/nra-cet-courses-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>NRA CET</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Hotel Management & Catering Technology">
                            <MenuItem><Link to="/hotel-management-courses-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>Courses (Degree/Diploma/Craft)</Link></MenuItem>
                        </SubMenu>
                        <SubMenu label="Other Courses">
                            <MenuItem><Link to="/gate-coaching-centre-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>GATE</Link></MenuItem>
                            <MenuItem><Link to="/ugc-net-coaching-centre-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>NET</Link></MenuItem>
                            <MenuItem><Link to="/slet-coaching-centre-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>SLET</Link></MenuItem>
                            <MenuItem><Link to="/ies-training-institute-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>IES</Link></MenuItem>
                            <MenuItem><Link to="/engineering-and-architecture-guidance-program" style={{ display: 'block', width: '100%', height: '100%' }}>Engineering & Architecture Guidance Program</Link></MenuItem>
                            <MenuItem><Link to="/tnpsc-coaching-centre-in-chennai" style={{ display: 'block', width: '100%', height: '100%' }}>TNPSC, TRB, Police Exams & RRB</Link></MenuItem>
                        </SubMenu>
                    </Menu>
                    </li>
                  <li>
                    <Menu menuButton={<MenuButton>Admission & Payment <i className="fa fa-caret-down" /></MenuButton>}>
                      <MenuItem><Link to="/online-payment" style={{ display: 'block', width: '100%', height: '100%' }}>Online Payment</Link></MenuItem>
                      <MenuItem><Link to="/rules-and-regulations" style={{ display: 'block', width: '100%', height: '100%' }}>Rules and Regulations</Link></MenuItem>
                    </Menu>
                  </li>
                   
                    <li><Link to="/contact">Contact Us</Link></li>
                  </ul>
                </div>

                <div className="nav-right-part nav-right-part-desktop book-seat-container">
        <button className="book-seat-btn" onClick={this.handleNavigation}>
          Register for Query
        </button>
      </div>



<div className="nav-right-part nav-right-part-desktop" style={{ float: 'right', marginLeft: '15px' }}>
  <a href="tel:9962924444" className="call-btn" 
     style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'black', fontSize: '16px', fontWeight: 'bold' }}>
    <img src={publicUrl + "assets/img/website/phone_calling.gif"} alt="Call" width={50} style={{ marginRight: '8px' }} />
    99629 24444
  </a>
</div>

              </div>
            </nav>
          </div>


        )
    }
}


export default withRouter(Navbar);